import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import "./assets/font/Kuunari/fonts.css";
import "./assets/font/Montserrat/fonts.css";
import { Accessories } from "./pages/accessories/AccessoriesPage";
import { Dealers } from "./pages/dealers/DealersPage";
import { Service } from "./pages/service/ServicePage";
import { Contact } from "./pages/contact/ContactPage";
import { DealersPortal } from "./pages/dealers-portal/Dealers-portalPage";
import { MsalProvider } from "@azure/msal-react";
import PrivateRoute from "./common/PrivateRoute";
import Layout from "./components/Layout";
import VehiclePartsLookup from "./pages/vehicle-parts-lookup/vehicle-parts-lookup";
import ShoppingCart from "./pages/shopping-cart/shopping-cart";
import VehiclePartsLookupDetails from "./pages/vehicle-parts-lookup-details/vehicle-parts-lookup-details";
import VehiclePartsLookupInfo from "./pages/vehicle-parts-lookup-info/vehicle-parts-lookup-info";
import { Detail1500E } from "./pages/detail/detail1500E";
import { Detail1000EFI } from "./pages/detail/detail1000EFI";
import { ToastContainer } from "react-toastify";
import InventoryList from "./pages/inventory-list/inventory-list";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-toastify/dist/ReactToastify.css";
import { RegionProvider } from "./context/RegionContext";
import RegionApp from "./RegionApp";
import RegionRedirect from "./components/RegionRedirect";
import ScrollToTop from "./common/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <RegionProvider>
        <Routes>
          {/* New Zealand Region - all routes under /nz/* */}
          <Route path="/nz/*" element={<RegionApp region="nz" />} />

          {/* USA Region - all routes under /us/* */}
          <Route path="/us/*" element={<RegionApp region="us" />} />

          {/* Root + catch-all: geo-detect region client-side (interim fix
              until server-side / CDN geo-routing is in place) */}
          <Route path="/" element={<RegionRedirect />} />
          <Route path="*" element={<RegionRedirect />} />

          <Route
            path="/dealers-portal"
            element={
              <PrivateRoute>
                <DealersPortal />
              </PrivateRoute>
            }
          />
          <Route
            path="/dealers-portal/vehicle-parts-lookup"
            element={
              <PrivateRoute>
                <VehiclePartsLookup />
              </PrivateRoute>
            }
          />

          <Route
            path="/shopping-cart"
            element={
              <PrivateRoute>
                <ShoppingCart />
              </PrivateRoute>
            }
          />

          <Route
            path="/dealers-portal/vehicle-parts-lookup/:id"
            element={
              <PrivateRoute>
                <VehiclePartsLookupDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/dealers-portal/vehicle-parts-lookup/:id/detail"
            element={
              <PrivateRoute>
                <VehiclePartsLookupInfo />
              </PrivateRoute>
            }
          />

          <Route
            path="/dealers-portal/inventory-list"
            element={
              <PrivateRoute>
                <InventoryList />
              </PrivateRoute>
            }
          />
        </Routes>
      </RegionProvider>
    </Router>
  );
}

export default App;
